import React from "react"
import Img from "gatsby-image"
import { graphql, useStaticQuery } from "gatsby"

import styles from "./index.module.scss"

const LinkCard = ({ url }) => {
  const query = useStaticQuery(
    graphql`
      query {
        allEmbedJson {
          nodes {
            url
            fields {
              image
              domain
              title
              url
            }
            image {
              childImageSharp {
                fluid(maxWidth: 1920, webpQuality: 90) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    `
  )

  const { nodes } = query.allEmbedJson
  let embed = nodes.find(node => node.url === url)
  const thumbnail = embed.image
  if (embed == null || thumbnail == null) {
    return <a href={url}>{url}</a>
  }

  return (
    <div id={styles.link_card}>
      <div id={styles.card_body}>
        <p href={embed.url} id={styles.link_card_title}>
          {embed.fields.title}
        </p>
        <p>{embed.fields.domain}</p>
      </div>
      <Img
        fluid={thumbnail.childImageSharp.fluid}
        id={styles.link_card_img}
        style={{ display: "inline-block", width: "10rem", height: "10rem" }}
        imgStyle={{ objectFit: "contain" }}
      />
      <a id={styles.link_card_root} href={url}>
        {" "}
      </a>
    </div>
  )
}

export default LinkCard
